import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef, useRef, useImperativeHandle, useEffect } from 'react';
import { getCommonClassNameDefault } from '@skatteetaten/ds-core-utils';
import { Icon, CheckSVGpath } from '@skatteetaten/ds-icons';
import './styles.css';


var styles = {
    "button": "TopBannerLangPickerButton-module_button__OIVkN",
    "flagWrapper": "TopBannerLangPickerButton-module_flagWrapper__h19uX",
    "buttonText": "TopBannerLangPickerButton-module_buttonText__SbE3c",
    "buttonCurrent": "TopBannerLangPickerButton-module_buttonCurrent__sMGG3"
};

const TopBannerLangPickerButton = /*#__PURE__*/ forwardRef(({ id, className = getCommonClassNameDefault(), lang, 'data-testid': dataTestId, flagIcon, ariaCurrent, focus, onClick, onKeyDown, children }, ref)=>{
    const concatenatedClassNames = `${ariaCurrent ? styles.buttonCurrent : ''} ${styles.button} ${className}`.trim();
    const refInternal = useRef(null);
    useImperativeHandle(ref, ()=>refInternal?.current);
    useEffect(()=>{
        if (focus) {
            refInternal.current?.focus();
        }
    }, [
        focus
    ]);
    return /*#__PURE__*/ jsxs("button", {
        ref: refInternal,
        id: id,
        className: concatenatedClassNames,
        lang: lang,
        "data-testid": dataTestId,
        "aria-current": ariaCurrent,
        onClick: onClick,
        onKeyDown: onKeyDown,
        children: [
            /*#__PURE__*/ jsx("span", {
                className: styles.flagWrapper,
                children: flagIcon
            }),
            /*#__PURE__*/ jsx("span", {
                className: styles.buttonText,
                children: children
            }),
            ariaCurrent && /*#__PURE__*/ jsx(Icon, {
                svgPath: CheckSVGpath
            })
        ]
    });
});
TopBannerLangPickerButton.displayName = 'TopBannerLangPickerButton';

export { TopBannerLangPickerButton };
